export const takeData = (resp) => resp.json().catch((err) => {
  throw new Error('API response error: cannot take data.', { cause: { err, resp } });
});

export const assertOk = (resp) => {
  if (resp.ok) return resp;
  throw new Error('API response is not OK.', { cause: resp });
};
